'use client'

import { getSession } from "next-auth/react";

async function getSessionObject() {
    let session;

    // We are on the client
    session = await getSession();


    return session
}

export async function getUserInfo() {

    const session = await getSessionObject()

    const user = session?.user;

    if (!user) {
        return null
    }

    let { id, email, name } = user;


    if (!name || name.trim() === '') {
        name = "U U"
    }

    const nameParts = name.split(' ');

    const given_name = nameParts[0];
    const family_name = nameParts.slice(1).join(' ');

    const attributes = {
        sub: id,
        email: email,
        given_name,
        family_name,
        name
    };

    return { ...user, attributes: attributes };
}



export async function isMember(id: string): Promise<boolean> {
    const user = await getUserInfo()
    if (user) {
        return user.id == id
    }
    return false;

}

export async function isAdmin(): Promise<boolean> {
    const user = await getUserInfo();
    if (user) {
        return user.role === "admin";
        // let results = await fetch("/api/admin/", {
        //     method: "PATCH",
        //     body: JSON.stringify({
        //         id: user.id
        //     })
        // })
        // return await results.json()
    }
    return false;

}

export async function isAuthenticated(): Promise<boolean> {
    let session
    session = await getSessionObject()
    return session != null

}